import type { SignalId } from "@repo/app-types/entities/signal";
import {
  getSimpleSelectOptionLabel,
  type SimpleSelectOption,
} from "@repo/ui/Select/simpleSelect";
import { useMemo } from "react";
import { useAllSignalsQuery } from "../api/entities/signal.js";

export function useSignalSelectOptions(): SimpleSelectOption<SignalId>[] {
  const { data: signals } = useAllSignalsQuery();

  const options = useMemo(() => {
    // TODO: Better loading state.
    if (!signals) {
      return [];
    }

    const options: SimpleSelectOption<SignalId>[] = signals.map((signal) => ({
      value: signal.id,
      label: signal.name,
    }));

    return options;
  }, [signals]);

  return options;
}

export function useSignalSelectLabel(
  options: SimpleSelectOption<SignalId>[],
  selectedSignalId: SignalId | undefined,
) {
  return useMemo(() => {
    if (!options || !selectedSignalId) {
      return undefined;
    }

    return getSimpleSelectOptionLabel(options, selectedSignalId) ?? "Unknown";
  }, [options, selectedSignalId]);
}
